module.exports = __webpack_public_path__ + "img/arcadia-logo.1812ce67.png";